/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import race from './modules/race/state'
import router from '@/router'
import { removeAuthToken, setAuthToken } from '@/utils/session'
import { loginPost, logout } from "../api/auth";

export default {
  async login(_, payload) {
    const { data } = await loginPost(payload)
    setAuthToken(data.token)
    router.push({ name: 'dashboard' })
  },
  logout({ commit }) {
    logout()
      .then(res => {
        const payload = {
          race
        }
        removeAuthToken()
        commit('logout', payload)
        if (process.env.VUE_APP_IS_AAD_LOGIN === 'true') {
          window.location = res.data.redirect
        } else {
          router.push({name: 'login'})
        }
      })
  },
  clearStore ({commit}) {
    const payload = {
      race
    }
    commit('logout', payload)
    removeAuthToken()
    router.push({ name: 'login' })
  },
  updateAuthToken (_, payload) {
    setAuthToken(payload.token)
    router.push({ name: 'dashboard' })
  },
}
